const mobileAppServicesData = [
  {
    title: "Native iOS Development",
    description:
      "Build high‑performance iOS apps with Swift and SwiftUI tailored to Apple’s ecosystem.",
    bullets: [
      "Swift/SwiftUI",
      "App Store Guidelines",
      "Performance & Security",
      "Widget/Extension Support",
    ],
    minHeight: 400,
  },
  {
    title: "Native Android Development",
    description:
      "Robust Android apps using Kotlin with modern Jetpack libraries and architecture.",
    bullets: [
      "Kotlin",
      "Jetpack Compose",
      "MVVM/Clean Arch",
      "Play Store Compliance",
    ],
    minHeight: 400,
  },
  {
    title: "Cross‑Platform App Development",
    description:
      "React Native/Flutter apps that deliver native‑like UX across iOS and Android.",
    bullets: [
      "Single Codebase",
      "Faster Time‑to‑Market",
      "Native Modules",
      "OTA Updates",
    ],
    minHeight: 400,
  },
  {
    title: "Mobile UI/UX & Prototyping",
    description:
      "Pixel‑perfect designs, clickable prototypes, and usability testing for higher engagement.",
    bullets: [
      "Design Systems",
      "Accessibility",
      "Prototyping",
      "Usability Testing",
    ],
    minHeight: 400,
  },
  {
    title: "Backend & APIs for Mobile",
    description:
      "Secure, scalable APIs and push infra powering your mobile experiences.",
    bullets: [
      "Node/.NET/Python",
      "REST/GraphQL",
      "Push Notifications",
      "Auth & Payments",
    ],
    minHeight: 400,
  },
  {
    title: "App Maintenance & Growth",
    description:
      "Crash monitoring, OS upgrades, feature sprints, and ASO to scale your app.",
    bullets: [
      "SLA Support",
      "Crashlytics/Monitoring",
      "ASO",
      "Analytics & Experiments",
    ],
    minHeight: 400,
  },
];

export default mobileAppServicesData;
